import React from 'react';
import { mapControlStyles } from './map.util';

interface LegendProps {
  data: { area: string; color: string }[];
}

const MapLegend: React.FC<LegendProps> = ({ data }) => {
  return (
    <div style={legendContainerStyle}>
      <ul style={legendListStyle}>
        {data.map((item, index) => (
          <li key={index} style={legendItemStyle}>
            <span style={{ ...colorBoxStyle, backgroundColor: item.color }}></span>
            {item.area}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MapLegend;

// Inline styles
const legendContainerStyle: React.CSSProperties = {
  paddingInline: '10px',
  paddingBlock: '10px',
  fontFamily: 'Arial, sans-serif',
  zIndex: 1000,
  ...mapControlStyles,
};

const legendListStyle: React.CSSProperties = {
  listStyle: 'none',
  margin: '0',
  padding: 0,
  display: 'flex',
  flexDirection: 'row',
  gap: '10px',
};

const legendItemStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  marginBottom: '4px',
  fontSize: '14px',
};

const colorBoxStyle: React.CSSProperties = {
  width: '14px',
  height: '14px',
  marginRight: '8px',
  border: '1px solid #ccc',
  borderRadius: '50%',
};
